import React from 'react';

import FirebaseContext from './Firebase';

export const withFirebase = Component => props => (
  <FirebaseContext.Consumer>
    {firebase => <Component {...props} firebase={firebase} />}
  </FirebaseContext.Consumer>
);

export default FirebaseContext;



// WEBPACK FOOTER //
// ./src/components/withFirebase.js